/* unplugin-vue-components disabled */import { render } from "./position.vue?vue&type=template&id=7074891b&scoped=true"
import script from "./position.vue?vue&type=script&lang=js"
export * from "./position.vue?vue&type=script&lang=js"

import "./position.vue?vue&type=style&index=0&id=7074891b&lang=less&scoped=true"

import exportComponent from "/Users/yfy/work/work/cms-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7074891b"]])

export default __exports__